import * as React from 'react';
import { FC, SVGProps } from 'react';

const Triangle: FC<SVGProps<SVGSVGElement>> = props => (
    <svg
        width={10}
        height={7}
        viewBox="0 0 10 7"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path d="M5 6.97551L0.669873 0.975509L9.33013 0.97551L5 6.97551Z" />
    </svg>
);

export default Triangle;
